<template>
  <v-dialog
    class="share-price-widget"
    v-model="dialog"
    width="580"
    lazy
  >

    <slot slot="activator"></slot>

      <v-card>
        <v-card-title
          class="widget__heading"
        >
        Share Price
        </v-card-title>

        <v-card-text>

          <p>Before using this widget please contact Urban Zoo </p>

        <v-form enctype="multipart/form-data" v-model="valid" ref="sharePriceForm" lazy-validation>

          <section>

            <v-btn
              color="accent"
              outline
              flat
              @click="dialog = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="accent"
              depressed
              @click="validate()"
            >
              Add Share Price
            </v-btn>
          </section>

        </v-form>

        </v-card-text>
      </v-card>

  </v-dialog>
</template>

<script>

export default {
  name: "SharePriceWidget",

  props: {
    widgetData: {
      type: Object,
      required: false
    },
  },

  data: () => ({
    dialog: false
  }),

  mounted() {
    console.log("Share Price widget mounted");
  },

  methods: {
    validate() {
      this.errorMessage = ""
      if (this.$refs.sharePriceForm.validate()) {
        console.log("Validation passed");
        this.updateData();
      } else {
        this.errorMessage = "Certain entries are invalid or required"
      }
    },

    updateData() {
      console.log("Update share price data:");
      this.$emit("updatedData");
      this.dialog = false;
    }
  }
}
</script>

<style lang="scss" scoped>
  .edit {
    margin: 0 10px 20px 0;
    width: 100%;
  }
</style>